module.exports = __webpack_public_path__ + "static/media/RegionRole.585871c0.svg";